import { SearchProjects } from '@platform/client';
import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { CauseSelectionDropdown } from '../../components/CauseSelectionDropdown';
import { LanguageSelectionDropdown } from '../../components/LanguageSelectionDropdown';
import { PaginationBar } from '../../components/PaginationBar';
import { RoleTypeSelectionDropdown } from '../../components/RoleTypeSelectionDropdown';
import { SkillCategorySelectionDropdown } from '../../components/SkillCategorySelectionDropdown';
import { ProjectCard } from './ProjectCard';

const ProjectPageSize = 50;

export const ProjectCards = () => {
  const [sdgSelection, setSdgSelection] = useState<string[]>([]);
  const [languageSelection, setLanguageSelection] = useState<string[]>([]);
  const [skillCategorySelection, setSkillCategorySelection] = useState<string[]>([]);
  const [roleSelection, setRoleSelection] = useState<string[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(0);

  const data = SearchProjects.useSearchProjects({
    causes: sdgSelection.join(';'),
    languages: languageSelection.join(';'),
    skills: skillCategorySelection.join(';'),
    roles: roleSelection.join(';'),
    page: currentPage,
    limit: ProjectPageSize,
  });
  const numProjects = data.data?.filteredCount || 0;
  const numPages = Math.ceil(numProjects / ProjectPageSize);

  const onPageSelect = (page: number) => {
    setCurrentPage(page - 1);
  };

  return (
    <div>
      <div className='flex flex-col md:flex-row md:gap-4 text-lg'>
        <div className='w-full md:w-[350px] p-2 mx-auto md:mx-0'>
          <CauseSelectionDropdown
            selectedCauses={sdgSelection}
            onCausesSelectionChange={setSdgSelection}
            label='Causes'
          />
        </div>
        <div className='w-full md:w-[350px] p-2 mx-auto md:mx-0'>
          <LanguageSelectionDropdown
            selectedLanguages={languageSelection}
            onLanguageSelectionChange={setLanguageSelection}
            label='Languages'
          />
        </div>
        <div className='w-full md:w-[350px] p-2 mx-auto md:mx-0'>
          <SkillCategorySelectionDropdown
            selectedCategories={skillCategorySelection}
            onCategorySelectionChange={setSkillCategorySelection}
            label='Skill category'
            placeholder='Select skill category'
          />
        </div>
        <div className='w-full md:w-[350px] p-2 mx-auto md:mx-0'>
          <RoleTypeSelectionDropdown
            selectedRoleType={roleSelection}
            onRoleTypeSelectionChange={setRoleSelection}
            label='Support type'
            placeholder='Select support type'
          />
        </div>
      </div>
      <div className='border-t border-gray-100 pt-4 text-sm text-gray-500'>
        <span className='font-semibold text-gray-900'>{numProjects}</span> project
        {numProjects === 1 ? '' : 's'}
      </div>
      {data.isSuccess && (
        <div className='grid grid-cols-1 md:grid-cols-3 bg-gray-50 gap-6 pt-4 pb-10'>
          {data.data.projects.map((project) => {
            return <ProjectCard project={project} key={project.id} />;
          })}
        </div>
      )}
      {!data.isSuccess && <Skeleton />}
      <PaginationBar
        numPages={numPages}
        currentPage={currentPage + 1}
        onPageSelect={onPageSelect}
      />
    </div>
  );
};
